<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <div>
        <b-row>
          <b-col class=" mb-2" md="10">
            <strong style="font-size : 20px" class="tag-class ">
              Invoice Details</strong
            >
          </b-col>
        </b-row>
      </div>
      <b-card
        header="Customer Report"
        border-variant="info"
        header-bg-variant="primary"
        header-text-variant="white"
        class="full-width"
      >
        <div slot="header" class="mt-1">
          <b-row>
            <b-col md="6">
              <b-row>
                <b-col class="ml-1" md="6">
                  <b-row>
                    <b-col>
                      <strong style="font-size: 16px;" class="view-header-class"
                        >INVOICE</strong
                      >
                    </b-col>
                  </b-row>
                  <b-row class="mt-n2">
                    <b-col>
                      <strong class="view-header-class">
                        #{{ invoiceNumber }}</strong
                      >
                    </b-col>
                  </b-row>
                  <b-row class="mt-n2">
                    <b-col>
                      <strong class="view-header-class">
                        ₹
                        {{
                          this.getSingleInvoice.totalAmount.toFixed(2)
                        }}</strong
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <b-col>
                  <strong>
                    <ul>
                      <li
                        class="list-style view-header-class small-class"
                        :key="item._id"
                        v-for="item in invoiceBillTo.phone"
                      >
                        {{ item.number }}
                      </li>
                    </ul></strong
                  >
                </b-col>
              </b-row>
              <b-row class="mt-n3">
                <b-col>
                  <strong
                    ><ul>
                      <li
                        class="list-style mt-n2 ml-1 view-header-class small-class"
                        :key="item._id"
                        v-for="item in invoiceBillTo.email"
                      >
                        {{ item.mailId }}
                      </li>
                    </ul></strong
                  >
                </b-col>
              </b-row>
              <b-row class="mt-n3">
                <b-col>
                  <!-- <strong class="view-header-class small-class"
                  >Mywebsite.Com</strong
                > -->
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3">
              <b-row>
                <b-col md="8">
                  {{ invoiceBillTo.address.houseNumber }}
                  {{ invoiceBillTo.address.street1 }}
                  {{ invoiceBillTo.address.area }}
                  {{ invoiceBillTo.address.city }}
                  {{ invoiceBillTo.address.state }}
                  {{ invoiceBillTo.address.country }},
                  {{ invoiceBillTo.address.zip }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div>
          <b-row>
            <b-col md="4">
              <b-row>
                <b-col class="tag-class " md="3">Bill To : </b-col>
                <b-col class="info-class" md="6">
                  {{ invoiceBillTo.address.houseNumber }}
                  {{ invoiceBillTo.address.street1 }}
                  {{ invoiceBillTo.address.area }}
                  {{ invoiceBillTo.address.city }}
                  {{ invoiceBillTo.address.state }}
                  {{ invoiceBillTo.address.country }},
                  {{ invoiceBillTo.address.zip }}
                </b-col>
                <b-col md="3"></b-col>
              </b-row>
            </b-col>
            <b-col md="5">
              <b-row>
                <b-col class="tag-class ml-1" md="5">Invoice Date : </b-col>
                <b-col class="info-class" md="5">
                  {{ this.getSingleInvoice.invoiceDate }}
                </b-col>
                <b-col md="2"></b-col>
              </b-row>

              <b-row class="mt-n4">
                <b-col class="tag-class ml-1" md="5">Bill Period : </b-col>
                <b-col class="info-class" md="5">
                  {{ this.getSingleInvoice.billStartDate }} to
                  {{ this.getSingleInvoice.billEndDate }}
                </b-col>
                <b-col md="2"></b-col>
              </b-row>
            </b-col>

            <b-col md="3">
              <b-row>
                <b-col class="tag-class ml-1" md="5">Due Date : </b-col>
                <b-col class="info-class" md="6">
                  {{ this.getSingleInvoice.billDueDate }}
                </b-col>
                <b-col md="3"></b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <br />
        <br />
        <br />
        <div class="ml-5"></div>
        <br />
        <br />

        <b-table
          class="ml-5 mr-5"
          :dark="false"
          :hover="true"
          :striped="false"
          :bordered="true"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="invoiceDataList"
          :fields="invoiceDataColumns"
          thead-class="header1"
          show-empty
        >
          <template slot="description" slot-scope="data">
            <strong class="tag-class">{{ data.item.description[0] }}</strong>
            <p style="font-size : 13px;">
              {{ data.item.description[1] }}
            </p>
          </template>
        </b-table>
        <br />
        <br />
        <div>
          <b-row>
            <b-col md="8"> </b-col>
            <b-col md="4">
              <b-row>
                <b-col class="tag-class ml-1">Subtotal : </b-col>
                <b-col class="info-class">
                  ₹{{ this.getSingleInvoice.chargeAmount.toFixed(2) }}
                </b-col>
              </b-row>

              <!-- <b-row class="mt-n1">
              <b-col class="tag-class ml-1">Charge : </b-col>
              <b-col class="info-class">
                ₹3400
              </b-col>
            </b-row> -->

              <b-row class="mt-n1">
                <b-col class="tag-class ml-1">Tax : </b-col>
                <b-col class="info-class">
                  ₹{{ this.getSingleInvoice.totalTaxes.toFixed(2) }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <br />
          <b-row>
            <b-col md="8"> </b-col>
            <b-col md="4">
              <b-row>
                <b-col style="font-size: 25px;" class="tag-class ml-1">
                  Total :
                </b-col>
                <b-col style="font-size: 25px;" class="info-class">
                  ₹{{ this.getSingleInvoice.totalAmount.toFixed(2) }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <br />
        <br />

        <b-row>
          <b-col> </b-col>
          <b-col class="ml-5">
            <b-button
              btn-special="primary"
              class="footer-bottons-class"
              @click="back()"
              size="lg"
            >
              Back
            </b-button>
          </b-col>
          <b-col> </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  name: "InvoiceDetails",
  components: {
    loader
  },
  data() {
    return {
      loading: false,
      descriptionData: [],
      invoiceDataColumns: [
        {
          key: "itemId"
        },
        {
          key: "description"
        },
        {
          key: "unitCost"
        },
        {
          key: "quantity"
        },
        {
          key: "amount"
        },
        {
          key: "tax"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      getSingleInvoice: "invoice/GetSingleInvoice",
      getInvoiceBill: "invoice/GetInvoiceBill",
      partnerAllData: "partner/GetPartnerData",
      partnerSubscribedList: "subscription/GetSubscriptionPartnerList",
      subscriptionList: "subscription/GetSubscriptionList"
    }),
    invoiceNumber() {
      let num = this.getSingleInvoice.invoiceNumber.toString();
      while (num.length < 10) num = "0" + num;
      return num;
    },
    invoiceDataList() {
      let data = this.getInvoiceBill;
      let invoiceBill = [];

      if (Array.isArray(data) && data.length > 0) {
        data.map(obj => {
          this.descriptionOfEachItem(obj.subscription);
          let arrObj = {
            description: this.descriptionData,
            unitCost: obj.unitPrice,
            quantity: obj.quantity,
            amount: obj.itemTotal,
            tax: obj.taxAmount,
            itemId: "#" + obj.chargeRef
          };
          invoiceBill.push(arrObj);
        });
        return invoiceBill;
      } else {
        return [];
      }
    },
    invoiceBillTo() {
      if (this.partnerAllData.bill_to.length > 0) {
        return this.partnerAllData.bill_to[0];
      } else {
        return this.partnerAllData.office;
      }
    }
  },
  methods: {
    back() {
      this.$router.push("/partner/view/view-invoice");
    },

    descriptionOfEachItem(subsId) {
      this.descriptionData = [];
      let matchedBill = this.partnerSubscribedList.filter(obj => {
        return obj._id == subsId;
      });
      if (matchedBill.length > 0) {
        let descriptionPlan = this.subscriptionList.filter(obj => {
          return obj._id == matchedBill[0].plan;
        });
        if (descriptionPlan.length > 0) {
          this.descriptionData = [
            descriptionPlan[0].planName,
            descriptionPlan[0].planDescription
          ];
        } else {
        }
      } else {
      }
    }
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch(
      "invoice/partnerInvoiceBill",
      this.getSingleInvoice.invoiceNumber
    );

    await this.$store
      .dispatch("subscription/getSubscriptionPartner", {
        id: this.partnerAllData._id,
        data: {}
      })
      .then(data => {
        if (data.message) {
          console.log(data.message);
        }
      });
    await this.$store.dispatch("subscription/fetchSubscriptionList");
    this.loading = false;
  }
};
</script>
<style scoped>
.view-header-class {
  font-family: 'Lato';
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;

  text-transform: capitalize;

  color: white;
}

.small-class {
  font-size: 15px;
}
.tag-class {
  font-family: 'Lato';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: right;
  text-transform: capitalize;

  color: #000000;
}
.info-class {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;

  text-transform: capitalize;

  color: #8a76df;
}
.list-style {
  list-style-type: none;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 39px;
  width: 120px;
  background-color: #727cf5;
  color: white;
}
</style>
